import { z } from "zod";
//
// TO DELETE!
//
/**
 * @deprecated
 */
export const DTODocumentationAnalyticsTimeFrameComparison = z.object({
    referencePeriod: z.object({
        start: z.coerce.date(),
        end: z.coerce.date().optional(),
    }),
    baselinePeriod: z.object({
        start: z.coerce.date(),
        end: z.coerce.date().optional(),
    }),
});
/**
 * @deprecated
 */
export const DTODocumentationAnalyticsDiffPayload = z.object({
    timeFrames: z.array(DTODocumentationAnalyticsTimeFrameComparison),
});
